export const getters = {
    confirmationModal: state => state.confirmationModal,
    isConfirmShown: state => state.isConfirmShown,
    isFadeShown: state => state.isFadeShown
};


// WEBPACK FOOTER //
// ./src/store/modules/confirmModal/getters.js